<template>
  <Modal
    ref="confirmModal"
    :showCloseBtn="false"
    :modalId="modalId"
    :modalType="modalType"
  >
    <div slot="modal-header">
      <p
        :class="['action-confirm-title', requiredFlag ? 'required-flag': '' ]"
        v-html="confirmTitleText"
      />
    </div>
    <div slot="content">
      <slot name="content" />
    </div>
    <div slot="btns">
      <button
        v-if="showCancelBtn"
        type="button"
        class="btn btn--darkblue"
        @click="cancel()"
      >{{ cancelBtnText }}</button>
      <button
        :disabled="disabledConfirmBtn"
        type="button"
        class="btn btn--orange"
        @click="confirm()"
      >{{ confirmBtnText }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
export default {
  name: 'actionConfirmModal',
  components: {
    Modal,
  },
  props: {
    modalId: {
      type: String,
    },
    modalType: {
      type: String,
      default: 'small-modal', // medium-modal large-modal
    },
    confirmBtnName: {
      type: String,
      default: 'action.yes',
    },
    cancelBtnName: {
      type: String,
      default: 'action.cancel',
    },
    confirmTitle: {
      type: String,
      default: 'confirmAction',
    },
    requiredFlag: {
      type: Boolean,
      default: false,
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    disabledConfirmBtn: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      confirmAction: {
        type: Function,
        default: () => {},
      },
      params: {
        type: Array,
        default: [],
      },
      cancelAction: {
        type: Function,
        default: () => {},
      },
    }
  },
  computed: {
    cancelBtnText () {
      return this.$te(this.cancelBtnName) ? this.$t(this.cancelBtnName) : this.cancelBtnName
    },
    confirmBtnText () {
      return this.$te(this.confirmBtnName) ? this.$t(this.confirmBtnName) : this.confirmBtnName
    },
    confirmTitleText () {
      return this.$te(this.confirmTitle) ? this.$t(this.confirmTitle) : this.confirmTitle
    },
  },
  methods: {
    open (confirmAction, params = [], cancelAction) {
      this.confirmAction = confirmAction
      this.params = params
      this.cancelAction = cancelAction
      this.$refs.confirmModal.open()
    },
    async cancel () {
      if (typeof this.cancelAction === 'function') {
        await this.cancelAction()
      }
      this.$refs.confirmModal.close()
      this.$emit('action:afterClose')
    },
    async confirm () {
      this.$refs.confirmModal.close()
      if (typeof this.confirmAction === 'function') {
        await this.confirmAction(...this.params)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.action-confirm-title {
  font-size: 14px;
  font-weight: bold;
  color: #0c3a58;
  white-space: pre-line;
}
</style>
